import React, {useState} from "react";
import {useFolderStore} from "../../app/store/FolderStore";
import Input from "../common/Input";
import styled from "styled-components";

const BookmarkAddView = ({
                             entryType,
                             isActionModal,
                             mutateFoldersAndBookmarks,
                         }) => {
    const folderStore = useFolderStore();
    const [bookmarkName, setBookmarkName] = useState(folderStore.getAddBookmark(entryType, isActionModal).name);

    const bookmarkAction = async (ev) => {
        if (ev.nativeEvent.isComposing) return;
        try {
            await folderStore.bookmarkFolder(entryType, folderStore.getAddBookmark(entryType, isActionModal).id, bookmarkName);
            folderStore.setAddBookmark(entryType, undefined, isActionModal);
            await mutateFoldersAndBookmarks();
        } catch (e) {
            folderStore.setAddBookmark(entryType, undefined, isActionModal);
            console.log('err ====>', e.message);
        }
    }
    return (
        <EntryContainer id={"add-bookmark-input"}>
            <Input
                inputType={"text"}
                placeholder={"즐겨찾기 이름"}
                autoFocus={true}
                onChange={(e) => {
                    setBookmarkName(e.target.value);
                }}
                onBlur={async (ev) => {
                    await bookmarkAction(ev)
                }}
                onKeyDown={async (ev) => {
                    // eslint-disable-next-line default-case
                    switch (ev.key) {
                        case 'Escape':
                            folderStore.setAddBookmark(entryType, undefined, isActionModal);
                            break;
                        case 'Enter':
                            await bookmarkAction(ev)
                            break;
                    }
                }}
                // onFocus={true}
                value={bookmarkName}
            />
        </EntryContainer>
    );
};
export default BookmarkAddView;

export const EntryContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 16px;
    cursor: pointer;

    > div {
        width: 100%;
    }

    &#add-bookmark-input .input-wrapper input {
        margin: 6px 10px;
    }
`;
